export const GET_DASHBOARD_BEGIN = 'GET_DASHBOARD_BEGIN'
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'
export const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE'

export const DASHBOARD_SET_FILTER ='DASHBOARD_SET_FILTER'
export const DASHBOARD_SET_FILTER_DATE ='DASHBOARD_SET_FILTER_DATE'

export const CLEAR_DASHBOARD_SETTINGS = 'CLEAR_DASHBOARD_SETTINGS'
export const DASHBOARD_SET_GROUP_SELECTOR = 'DASHBOARD_SET_GROUP_SELECTOR'
export const DASHBOARD_SET_SHOW_DASH_CARD = 'DASHBOARD_SET_SHOW_DASH_CARD'
export const DASHBOARD_SET_DEFAULT_DASH_CARD = 'DASHBOARD_SET_DEFAULT_DASH_CARD'